<template>
  <div
    ref="otherArticles"
    class="post-more"
  >
    <h2 class="title">Ещё на тему путешествий</h2>
    <div class="post-more__inner">
      <AppLink
        v-if="mainPost?.slug"
        class="post-more__main"
        :to="setUrl(mainPost.slug)"
        @click.stop="mainPost && otherClicked(mainPost)"
      >
        <img
          :src="lightboxUrl(mainPost)"
          loading="lazy"
          :alt="mainPost.title"
        />
        <span class="post-more__main-text"> <b v-html="mainPost.title" /> <span v-html="mainPost.tagline" /> </span>
      </AppLink>
      <nav
        v-if="postList.length"
        class="post-list"
      >
        <AppLink
          v-for="post in postList"
          :key="post.id"
          class="post-list__item"
          :to="setUrl(post.slug)"
          @click.stop="otherClicked(post)"
        >
          <span class="post-list__text"> <b v-html="post.title" /> <span v-html="post.tagline" /> </span>
          <img
            class="post-list__img"
            :src="thumbUrl(post)"
            loading="lazy"
            :alt="post.title"
          />
        </AppLink>
      </nav>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import type { RouteLocationRaw } from 'vue-router';
  import type { RelatedArticle } from '@/shared/api/experience';

  interface Props {
    posts: RelatedArticle[];
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{
    (e: 'otherClicked', post: RelatedArticle): void;
  }>();

  const route = useRoute();

  const otherArticles = ref<HTMLElement | null>(null);

  const mainPost = computed<RelatedArticle | undefined>(() => props.posts[0]);

  const postList = computed<RelatedArticle[]>(() => [...props.posts].slice(1, 5));

  const isArticle = computed(() => route.fullPath.includes('articles'));

  const otherClicked = (post: RelatedArticle): void => {
    emit('otherClicked', post);
  };

  const setUrl = (slug = ''): RouteLocationRaw =>
    isArticle.value ? `/journal/articles/${slug}/` : `/journal/sights/${slug}/`;

  const lightboxUrl = (post: RelatedArticle | undefined): string =>
    post?.main_photo?.lightbox ?? post?.main_photo?.scaled ?? '';

  const thumbUrl = (post: RelatedArticle): string => post.main_photo?.thumbnail_s ?? post.main_photo?.thumbnail ?? '';
</script>

<style lang="scss">
  @import '@/app/styles/post_page';

  .title {
    @include base-800-750-extra;

    @include tablet {
      @include base-700-500-extra;
    }
  }
</style>
